import { render } from "./ExpireTrangPopup.vue?vue&type=template&id=0fc9a35a"
import script from "./ExpireTrangPopup.vue?vue&type=script&lang=js"
export * from "./ExpireTrangPopup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeniel/Works/tranggle/old-tranggle-www-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__